import { createElement, useState } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { FaSortDown } from 'react-icons/fa';
import { FaCaretRight } from 'react-icons/fa';
import { settingsPanelStyles as styles } from './styles';
//import { SketchPicker } from 'react-color';
import { ChromePicker } from 'react-color';
import { EditableInput } from 'react-color/lib/components/common';
import reactCSS from 'reactcss';

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

interface IPropsBorderRow {
    name: string;
    field: string;
    className: string;
    descriptor: ComponentDesc<any>;
}

class _BorderRow extends Component<IProps, any> {
    state = {
        displayColorPicker: false,
    };

    handleChangeColor = (borderColor) => {
        this.props.descriptor.style.borderColor = borderColor.hex;
    };

    updateAllBorder(field, r) {
        this.props.descriptor.style['border' + field] = r;
        this.props.descriptor.style['borderTop' + field] = r;
        this.props.descriptor.style['borderBottom' + field] = r;
        this.props.descriptor.style['borderLeft' + field] = r;
        this.props.descriptor.style['borderRight' + field] = r;
    }

    render() {
        const { name, field, descriptor, className } = this.props;

        const swatchBoxStyles = {
            width: '50px',
            height: '30px',
            borderRadius: '2px',
            backgroundColor: descriptor.style[field + 'Color'] || '#DDDDDD',
        };
        console.log('rendering BorderRow, ', swatchBoxStyles, name, field, descriptor);

        const styles = reactCSS({
            default: {
                borderColor: {
                    width: '50px',
                    height: '14px',
                    borderRadius: '2px',
                },

                swatch: {
                    padding: '5px',
                    background: '#DDDDDD',
                    borderRadius: '1px',
                    boxShadow: '#DDDDDD',
                    display: 'inline-block',
                    cursor: 'pointer',
                    width: 50,
                    marginRight: '10px',
                },
                popover: {
                    position: 'absolute',
                    right: '0',
                    bottom: '50px',
                    zIndex: 1,
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
                root: {
                    display: 'flex',
                    flexDirection: 'column',
                },
            },
        });

        return (
            <tr>
                <td>{name}</td>
                <td>
                    <input type="number" defaultValue={descriptor.style[field + 'Width']} onChange={(e) => (name === 'All' ? this.updateAllBorder('Width', +e.target.value) : (descriptor.style[field + 'Width'] = +e.target.value))} className={className + ' borderWidthInputBox'} />
                </td>
                <td>
                    <select
                        className={className + ' borderstyleInputBox'}
                        defaultValue={descriptor.style[field + 'Style']}
                        onChange={(e) => (name === 'All' ? this.updateAllBorder('Style', e.target.value) : e.target.value != '--Select--' ? (descriptor.style[field + 'Style'] = e.target.value) : '')}
                        style={{
                            color: '#2F343E',
                        }}>
                        <option>--Select--</option>
                        <option>Solid</option>
                        <option>Dotted</option>
                        <option>Dashed</option>
                        <option>Double</option>
                        <option>groove</option>
                        <option>inset</option>
                        <option>outset</option>
                        <option>hidden</option>
                        <option>none</option>
                    </select>
                </td>
                <td>
                    <div
                        style={swatchBoxStyles}
                        onClick={(e) =>
                            this.setState({
                                displayColorPicker: !this.state.displayColorPicker,
                            })
                        }>
                        <div style={styles.borderColor} className="borderColor" />
                        {/* <EditableInput
                            label="Color"
                            value={ descriptor.style[field + 'Color']  || '#000'}
                            onChangeComplete={ this.handleChangeColor(field) } /> */}
                    </div>
                    {this.state.displayColorPicker ? (
                        <div style={styles.popover}>
                            <div
                                style={styles.cover}
                                onClick={(e) =>
                                    this.setState({
                                        displayColorPicker: !this.state.displayColorPicker,
                                    })
                                }
                            />
                            <ChromePicker color={this.props.descriptor.style.borderColor} onChange={this.handleChangeColor} />
                        </div>
                    ) : null}
                </td>
            </tr>
        );
    }
}

const BorderRow = observer(_BorderRow);

class BorderEdit extends Component<IProps, any> {
    state = {
        isExpanded: false,
        isChecked: false,
        isBorderRadiusExpanded: false,
    };

    equateAllBorder() {
        this.setState({ isChecked: !this.state.isChecked });
    }

    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;

        return (
            <div style={{ position: 'relative' }} className={classes.root}>
                <table>
                    <tbody className={classes.header}>
                        <tr
                            onClick={(e) =>
                                this.setState({
                                    isExpanded: !this.state.isExpanded,
                                })
                            }>
                            <td>
                                {!this.state.isExpanded ? <FaCaretRight className={classes.icon} /> : <FaSortDown className={classes.icon} />}
                                Border
                            </td>
                            <td className={classes.td}>Width</td>
                            <td className={classes.td}>Style</td>
                            <td className={classes.td}>Color</td>
                        </tr>
                        {!this.state.isExpanded ? <BorderRow name={'All'} descriptor={descriptor} className={classes.input} field={'border'} /> : null}
                    </tbody>
                    {this.state.isExpanded ? (
                        <tbody className={classes.sub_header}>
                            <BorderRow name={'Top'} descriptor={descriptor} className={classes.input} field={'borderTop'} />
                            <BorderRow name={'Right'} descriptor={descriptor} className={classes.input} field={'borderRight'} />
                            <BorderRow name={'Bottom'} descriptor={descriptor} className={classes.input} field={'borderBottom'} />
                            <BorderRow name={'Left'} descriptor={descriptor} className={classes.input} field={'borderLeft'} />
                        </tbody>
                    ) : null}
                </table>
            </div>
        );
    }
}
export default withStyles(styles)(observer(BorderEdit));
